// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-booking-page {
  --pb-ink: #0b3a4a;
  --pb-deep: #062a36;
  --pb-gold: #c9a227;
  --pb-sand: #f4f7f8;
  --pb-card: #ffffff;
  background:
    radial-gradient(ellipse 80% 50% at 50% -10%, rgba(14, 165, 233, 0.08), transparent 55%),
    linear-gradient(180deg, #e8f4f8 0%, var(--pb-sand) 28%, #f8fafb 100%);
  min-height: 100vh;
}

.public-booking-hero {
  position: relative;
  overflow: hidden;
  color: #fff;
  isolation: isolate;
}

.public-booking-hero__media {
  position: absolute;
  inset: -8%;
  z-index: 0;
  will-change: transform;
  animation: pb-kenburns 28s ease-in-out infinite alternate;
}

.public-booking-hero__media img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 35%;
  display: block;
  transform: scale(1.08);
}

.public-booking-hero__veil {
  position: absolute;
  inset: 0;
  z-index: 1;
  background:
    linear-gradient(180deg, rgba(4, 12, 28, 0.35) 0%, rgba(4, 12, 28, 0.55) 48%, rgba(4, 12, 28, 0.9) 100%),
    radial-gradient(ellipse 55% 45% at 50% 30%, rgba(201, 162, 39, 0.16), transparent 70%);
  pointer-events: none;
}

.public-booking-hero__shimmer {
  position: absolute;
  inset: 0;
  z-index: 2;
  background: linear-gradient(
    115deg,
    transparent 30%,
    rgba(255, 255, 255, 0.07) 48%,
    transparent 62%
  );
  background-size: 220% 100%;
  animation: pb-shimmer 9s ease-in-out infinite;
  pointer-events: none;
}

.public-booking-hero__content {
  position: relative;
  z-index: 3;
}

.public-booking-hero__brand {
  animation: pb-rise 0.9s ease-out both;
}

.public-booking-hero__title {
  animation: pb-rise 1s 0.12s ease-out both;
}

.public-booking-hero__sub {
  animation: pb-rise 1s 0.22s ease-out both;
}

.public-booking-section {
  background: var(--pb-card);
  border: 1px solid rgba(11, 58, 74, 0.08);
  border-radius: 1.25rem;
  box-shadow: 0 10px 30px -18px rgba(6, 42, 54, 0.35);
}

.public-booking-timeline {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  gap: 0;
  padding: 0 0.25rem;
}

.public-booking-timeline__track {
  position: absolute;
  top: 0.95rem;
  right: calc(10% + 0.1rem);
  left: calc(10% + 0.1rem);
  height: 3px;
  border-radius: 9999px;
  background: #e2e8f0;
  z-index: 0;
  overflow: hidden;
}

.public-booking-timeline__progress {
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(to left, #0ea5e9, #0369a1);
  transition: width 0.3s ease;
}

.public-booking-timeline__item {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
  z-index: 1;
  min-width: 0;
  background: transparent;
  border: 0;
  padding: 0;
  cursor: default;
}

.public-booking-timeline__item--clickable {
  cursor: pointer;
}

.public-booking-timeline__item--clickable:hover .public-booking-timeline__dot {
  transform: scale(1.06);
}

.public-booking-timeline__dot {
  width: 2rem;
  height: 2rem;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  border: 2px solid #cbd5e1;
  background: #fff;
  color: #64748b;
  transition: all 0.2s ease;
  box-shadow: 0 0 0 4px #fff;
}

.public-booking-timeline__item--done .public-booking-timeline__dot {
  background: linear-gradient(135deg, #0369a1, #0ea5e9);
  border-color: transparent;
  color: #fff;
}

.public-booking-timeline__item--active .public-booking-timeline__dot {
  background: #fff;
  border-color: #0284c7;
  color: #0369a1;
  box-shadow: 0 0 0 4px rgba(14, 165, 233, 0.18);
}

.public-booking-timeline__label {
  margin-top: 0.55rem;
  font-size: 0.72rem;
  font-weight: 600;
  color: #94a3b8;
  line-height: 1.25;
  white-space: nowrap;
}

.public-booking-timeline__item--done .public-booking-timeline__label,
.public-booking-timeline__item--active .public-booking-timeline__label {
  color: #0f172a;
}

.public-booking-nav {
  display: flex;
  gap: 0.75rem;
  margin-top: 1.25rem;
}

.public-booking-nav__btn {
  flex: 1 1;
  border-radius: 0.9rem;
  padding: 0.85rem 1rem;
  font-size: 0.875rem;
  font-weight: 600;
  transition: all 0.15s ease;
}

.public-booking-nav__btn--ghost {
  border: 1px solid #dbe3ea;
  background: #fff;
  color: #334155;
}

.public-booking-nav__btn--ghost:hover {
  background: #f8fafc;
}

.public-booking-nav__btn--primary {
  background: linear-gradient(to left, #075985, #0284c7);
  color: #fff;
  border: 0;
  box-shadow: 0 10px 20px -12px rgba(7, 89, 133, 0.55);
}

.public-booking-nav__btn--primary:hover {
  filter: brightness(1.05);
}

.public-booking-nav__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .public-booking-timeline__dot {
    width: 1.7rem;
    height: 1.7rem;
    font-size: 0.68rem;
  }

  .public-booking-timeline__track {
    top: 0.8rem;
  }

  .public-booking-timeline__label {
    font-size: 0.62rem;
  }
}

@keyframes pb-kenburns {
  0% {
    transform: scale(1) translate3d(0, 0, 0);
  }
  100% {
    transform: scale(1.12) translate3d(-2.5%, 1.5%, 0);
  }
}

@keyframes pb-shimmer {
  0%,
  100% {
    background-position: 120% 0;
    opacity: 0.35;
  }
  50% {
    background-position: -20% 0;
    opacity: 0.7;
  }
}

@keyframes pb-rise {
  from {
    opacity: 0;
    transform: translateY(14px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .public-booking-hero__media,
  .public-booking-hero__shimmer,
  .public-booking-hero__brand,
  .public-booking-hero__title,
  .public-booking-hero__sub {
    animation: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PublicBooking/public-booking.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB;;yEAEuE;EACvE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;;0FAEwF;EACxF,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV;;;;;GAKC;EACD,0BAA0B;EAC1B,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,MAAM;EACN,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,wBAAwB;EACxB,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,sDAAsD;EACtD,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sDAAsD;EACtD,WAAW;EACX,SAAS;EACT,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE;;IAEE,2BAA2B;IAC3B,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,YAAY;EACd;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;;;;IAKE,0BAA0B;EAC5B;AACF","sourcesContent":[".public-booking-page {\n  --pb-ink: #0b3a4a;\n  --pb-deep: #062a36;\n  --pb-gold: #c9a227;\n  --pb-sand: #f4f7f8;\n  --pb-card: #ffffff;\n  background:\n    radial-gradient(ellipse 80% 50% at 50% -10%, rgba(14, 165, 233, 0.08), transparent 55%),\n    linear-gradient(180deg, #e8f4f8 0%, var(--pb-sand) 28%, #f8fafb 100%);\n  min-height: 100vh;\n}\n\n.public-booking-hero {\n  position: relative;\n  overflow: hidden;\n  color: #fff;\n  isolation: isolate;\n}\n\n.public-booking-hero__media {\n  position: absolute;\n  inset: -8%;\n  z-index: 0;\n  will-change: transform;\n  animation: pb-kenburns 28s ease-in-out infinite alternate;\n}\n\n.public-booking-hero__media img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 35%;\n  display: block;\n  transform: scale(1.08);\n}\n\n.public-booking-hero__veil {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  background:\n    linear-gradient(180deg, rgba(4, 12, 28, 0.35) 0%, rgba(4, 12, 28, 0.55) 48%, rgba(4, 12, 28, 0.9) 100%),\n    radial-gradient(ellipse 55% 45% at 50% 30%, rgba(201, 162, 39, 0.16), transparent 70%);\n  pointer-events: none;\n}\n\n.public-booking-hero__shimmer {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  background: linear-gradient(\n    115deg,\n    transparent 30%,\n    rgba(255, 255, 255, 0.07) 48%,\n    transparent 62%\n  );\n  background-size: 220% 100%;\n  animation: pb-shimmer 9s ease-in-out infinite;\n  pointer-events: none;\n}\n\n.public-booking-hero__content {\n  position: relative;\n  z-index: 3;\n}\n\n.public-booking-hero__brand {\n  animation: pb-rise 0.9s ease-out both;\n}\n\n.public-booking-hero__title {\n  animation: pb-rise 1s 0.12s ease-out both;\n}\n\n.public-booking-hero__sub {\n  animation: pb-rise 1s 0.22s ease-out both;\n}\n\n.public-booking-section {\n  background: var(--pb-card);\n  border: 1px solid rgba(11, 58, 74, 0.08);\n  border-radius: 1.25rem;\n  box-shadow: 0 10px 30px -18px rgba(6, 42, 54, 0.35);\n}\n\n.public-booking-timeline {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  position: relative;\n  gap: 0;\n  padding: 0 0.25rem;\n}\n\n.public-booking-timeline__track {\n  position: absolute;\n  top: 0.95rem;\n  right: calc(10% + 0.1rem);\n  left: calc(10% + 0.1rem);\n  height: 3px;\n  border-radius: 9999px;\n  background: #e2e8f0;\n  z-index: 0;\n  overflow: hidden;\n}\n\n.public-booking-timeline__progress {\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(to left, #0ea5e9, #0369a1);\n  transition: width 0.3s ease;\n}\n\n.public-booking-timeline__item {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n  background: transparent;\n  border: 0;\n  padding: 0;\n  cursor: default;\n}\n\n.public-booking-timeline__item--clickable {\n  cursor: pointer;\n}\n\n.public-booking-timeline__item--clickable:hover .public-booking-timeline__dot {\n  transform: scale(1.06);\n}\n\n.public-booking-timeline__dot {\n  width: 2rem;\n  height: 2rem;\n  border-radius: 9999px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.75rem;\n  font-weight: 700;\n  border: 2px solid #cbd5e1;\n  background: #fff;\n  color: #64748b;\n  transition: all 0.2s ease;\n  box-shadow: 0 0 0 4px #fff;\n}\n\n.public-booking-timeline__item--done .public-booking-timeline__dot {\n  background: linear-gradient(135deg, #0369a1, #0ea5e9);\n  border-color: transparent;\n  color: #fff;\n}\n\n.public-booking-timeline__item--active .public-booking-timeline__dot {\n  background: #fff;\n  border-color: #0284c7;\n  color: #0369a1;\n  box-shadow: 0 0 0 4px rgba(14, 165, 233, 0.18);\n}\n\n.public-booking-timeline__label {\n  margin-top: 0.55rem;\n  font-size: 0.72rem;\n  font-weight: 600;\n  color: #94a3b8;\n  line-height: 1.25;\n  white-space: nowrap;\n}\n\n.public-booking-timeline__item--done .public-booking-timeline__label,\n.public-booking-timeline__item--active .public-booking-timeline__label {\n  color: #0f172a;\n}\n\n.public-booking-nav {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 1.25rem;\n}\n\n.public-booking-nav__btn {\n  flex: 1;\n  border-radius: 0.9rem;\n  padding: 0.85rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  transition: all 0.15s ease;\n}\n\n.public-booking-nav__btn--ghost {\n  border: 1px solid #dbe3ea;\n  background: #fff;\n  color: #334155;\n}\n\n.public-booking-nav__btn--ghost:hover {\n  background: #f8fafc;\n}\n\n.public-booking-nav__btn--primary {\n  background: linear-gradient(to left, #075985, #0284c7);\n  color: #fff;\n  border: 0;\n  box-shadow: 0 10px 20px -12px rgba(7, 89, 133, 0.55);\n}\n\n.public-booking-nav__btn--primary:hover {\n  filter: brightness(1.05);\n}\n\n.public-booking-nav__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n@media (max-width: 480px) {\n  .public-booking-timeline__dot {\n    width: 1.7rem;\n    height: 1.7rem;\n    font-size: 0.68rem;\n  }\n\n  .public-booking-timeline__track {\n    top: 0.8rem;\n  }\n\n  .public-booking-timeline__label {\n    font-size: 0.62rem;\n  }\n}\n\n@keyframes pb-kenburns {\n  0% {\n    transform: scale(1) translate3d(0, 0, 0);\n  }\n  100% {\n    transform: scale(1.12) translate3d(-2.5%, 1.5%, 0);\n  }\n}\n\n@keyframes pb-shimmer {\n  0%,\n  100% {\n    background-position: 120% 0;\n    opacity: 0.35;\n  }\n  50% {\n    background-position: -20% 0;\n    opacity: 0.7;\n  }\n}\n\n@keyframes pb-rise {\n  from {\n    opacity: 0;\n    transform: translateY(14px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .public-booking-hero__media,\n  .public-booking-hero__shimmer,\n  .public-booking-hero__brand,\n  .public-booking-hero__title,\n  .public-booking-hero__sub {\n    animation: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
